// Loading Spinner
// ===============

import React from 'react'
import style from './index.module.scss'
import cx from 'classnames'

export type SpinnerType = 'default' | 'large'
interface SpinnerProps extends SpinnerVariantProps {
  type?: SpinnerType
}

interface SpinnerVariantProps {
  className?: string
  isSeasonal?: boolean
}

const Spinner: React.FunctionComponent<SpinnerProps> = ({
  type = 'default',
  className,
  isSeasonal,
}) => {
  return type === 'default' ? (
    <SpinnerDefault className={className} isSeasonal={isSeasonal} />
  ) : (
    <SpinnerLarge className={className} isSeasonal={isSeasonal} />
  )
}

const SpinnerDefault: React.FunctionComponent<SpinnerVariantProps> = ({
  className,
  isSeasonal,
}) => {
  return (
    <svg
      className={cx(
        style.SpinnerDefault,
        { [style.SpinnerSeasonal]: isSeasonal },
        className
      )}
      width="25px"
      height="25px"
      viewBox="0 0 25 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(-4.000000, -4.000000)"
        fill="currentColor"
        fillRule="nonzero"
      >
        <path
          d="M16.5,28.5 C23.127417,28.5 28.5,23.127417 28.5,16.5 C28.5,9.872583
        23.127417,4.5 16.5,4.5 C9.872583,4.5 4.5,9.872583 4.5,16.5 C4.5,
        17.3284271 5.17157288,18 6,18 C6.82842712,18 7.5,17.3284271
        7.5,16.5 C7.5,11.5294373 11.5294373,7.5 16.5,7.5 C21.4705627,7.5
        25.5,11.5294373 25.5,16.5 C25.5,21.4705627 21.4705627,25.5 16.5,25.5
        C15.6715729,25.5 15,26.1715729 15,27 C15,27.8284271 15.6715729,28.5
        16.5,28.5 Z"
        />
      </g>
    </svg>
  )
}

const SpinnerLarge: React.FunctionComponent<SpinnerVariantProps> = ({
  className,
  isSeasonal,
}) => {
  return (
    <div
      className={cx(
        style.SpinnerLarge,
        { [style.SpinnerSeasonal]: isSeasonal },
        className
      )}
    />
  )
}

export default Spinner
